export const DAO_CODE = 'CUSTOMERS'  + '_DAO';
